// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__2NF1-","icon":"search_icon__1nNQ0","input":"search_input__1ikq0","button":"search_button__2R07a"};